import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class CheckboxUIModelT<T> implements ICheckable {
    public Id: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Position: number;
    public Model: T;
    public Visible: boolean = true;
    public Title: string;

    constructor(fields?: Partial<CheckboxUIModelT<T>>) {
        (Object as any).assign(this, fields);
    }

    public clone(): CheckboxUIModelT<T> {
        return new CheckboxUIModelT<T>(this);
    }
}

class CheckboxUIModel implements ICheckable {
    public Id: string;
    public AlternativeId: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Position: number;
    public Visible: boolean = true;
    public DataCy: string | null = null;

    constructor(fields?: Partial<CheckboxUIModel>) {
        (Object as any).assign(this, fields);
    }

    public static New(Id: string, Name: string, Checked: boolean): CheckboxUIModel {
        let cb = new CheckboxUIModel();
        cb.Id = Id;
        cb.Name = Name;
        cb.Checked = Checked;
        return cb;
    }

    public clone(): CheckboxUIModel {
        return new CheckboxUIModel(this);
    }
}

export { CheckboxUIModel, CheckboxUIModelT };
